import { Col, Form, Input, Modal, Row, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import showNotification from "@/components/common/notification";
import { TerminalApi } from "@/apis/terminal.aspi";
import "./index.scss";
import { Device } from "@/models/device";
import { MerchantDetailModel, Terminal } from "@/models/terminal";
import { LocationDetailModel } from "@/models/location";
import { MerchantRequest } from "@/models/merchant";
import { TerminalType } from "@/constants/app.enums";

export interface DeviceModalProps {
  visible: boolean;
  onClose:(isUpdated?: boolean) => void; 
  isMerchant?: boolean;
  merchantData?: MerchantDetailModel;
  locationData?: LocationDetailModel;
  terminalData?: Terminal;
  reloadLocationData?: () => void;
}

export function ModalUpdateDevice({
  visible,
  onClose,
  isMerchant,
  merchantData,
  locationData,
  terminalData,
  reloadLocationData,
}: DeviceModalProps) {
  const { t } = useTranslation();
  const [deviceForm] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  useEffect(() => {
    if(visible) {
      console.log(terminalData)
      deviceForm.resetFields();
      deviceForm.setFieldsValue({
        lszTerminalName: terminalData?.lszTerminalName,
        terminalSerialNumber: terminalData?.terminalSerialNumber,
        brand: terminalData?.brand,
        model: terminalData?.model,
        terminalType: terminalData?.terminalType == TerminalType.Kiosk ? "Kiosk" : "Payment",
        screenRevolution: terminalData?.screenRevolution,
      });

    }
  }, [visible]); // Empty dependency array ensures this runs once when the component mounts.

  const handleOk = () => {
    deviceForm.submit();
  };

  const handleCancel = () => {
    deviceForm.resetFields();
    onClose();
  };

  const handleCancelUpdated = () => {
    deviceForm.resetFields();
    onClose(true);
  };

  async function HandlePostDevice(values: any) {
    const model: Device = {
      lszTerminalName: values.lszTerminalName,
      terminalSerialNumber: values.TerminalSerialNumber,
      brand: values.Brand,
      category: values.Category,
      model: values.Model,
      terminalType: values.TerminalType,
      screenRevolution: values.ScreenRevolution,
      id: "123"
    };
  }

  async function handleDeviceOperation(values: any, isUpdate: boolean) {
    setIsEditLoading(true);
    console.log(locationData);
    console.log(merchantData);
    try {
      const model: Device = {
        ...(isUpdate && { id: terminalData?.id }),
        terminalSerialNumber: values.terminalSerialNumber,
        lszTerminalName: values.lszTerminalName,
        brand: values.brand,
        category: values.category,
        model: values.model,
        terminalType: values.terminalType,
        id: "",
        screenRevolution: values.screenRevolution,
      };

      const data = isUpdate
        ? await TerminalApi.updateDevice(model, terminalData?.id)
        : await TerminalApi.addDevice(model, locationData?.id, isMerchant ? merchantData?.id : "");

      if (data) {
        showNotification("success", t(isUpdate ? "Update Device successfully." : "Create Device successfully."));
        reloadLocationData && reloadLocationData();
        handleCancelUpdated();
      }
    } catch (error) {
    } finally {
      setIsEditLoading(false);
    }
  }

  async function handleFormSubmit(values: any) {
    if (terminalData?.id) {
      await handleDeviceOperation(values, true);
    } else {
      await handleDeviceOperation(values, false);
    }
  }

  function DeviceForm() {
    return (
      <>
        <Form
          className="modal-container"
          layout="vertical"
          labelWrap
          form={deviceForm}
          onFinish={handleFormSubmit}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Device Name"
                name="lszTerminalName"
                rules={[{ required: true, message: 'Please input the device name!' }]}
              >
                <Input className="input-base" placeholder="Enter Device Name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Serial Number"
                name="terminalSerialNumber"
                rules={[{ required: true, message: 'Please input the serial number!' }]}
              >
                <Input className="input-base" placeholder="Enter Serial Number" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>

            <Col span={12}>
              <Form.Item
                label="Device Type"
                name="terminalType"
                rules={[{ required: true, message: 'Please input the ID!' }]}
              >
                <Select
                  className="select-base"
                  placeholder="Select Type"
                  options={[
                    { value: 'Kiosk', label: 'Kiosk' },
                    { value: 'Payment', label: 'Payment' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Brand"
                name="brand"
              >
                <Input className="input-base" placeholder="Enter Brand" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Model"
                name="model"
              >
                <Input className="input-base" placeholder="Enter Model" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="locationId"
                label={"Location"}
              >
                <Input defaultValue={terminalData?.id ? terminalData.terminalLocation : locationData?.locationName} className="input-base" disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              {(isMerchant || terminalData?.merchantName) && <Form.Item
                name="merchantId"
                label={"Merchant"}
              >
                <Input defaultValue={terminalData?.id ? terminalData.merchantName : merchantData?.lszMerchantName} className="input-base" disabled />
              </Form.Item>}

            </Col>
          </Row>
        </Form>
      </>
    );
  }

  return (
    <>
      <Modal
        className="modal-setup"
        style={{ top: 170 }}
        width={800}
        open={visible}
        title={terminalData?.id ? "Edit Device" : "New Device"}
        onCancel={handleCancel}
        okButtonProps={{ loading: isEditLoading }}
        onOk={handleOk}
        maskClosable={false}
      >
        <Spin spinning={isLoading}>
          <DeviceForm />
        </Spin>
      </Modal>
    </>
  );
}

export default ModalUpdateDevice;
